import { IconAlertTriangle } from "@tabler/icons-react";
import { waybillStateFlags, waybillStateFlagsEnum } from "helpers/enums/waybillStateFlags";
import { flagVal } from "helpers/system";
import React from "react";

interface WaybillExternalState {
    intStateFlags: number;
    externalLink?: string | null;
}

const warnings = [
    {
        flag: waybillStateFlagsEnum.HasPartialDelivery,
        message:
            "Груз принят частично. Продолжите оформление ЭТрН в Контуре: оформите необходимые титулы, включая Т7 и завершающий Т4.",
        action: "Перейти в Контур",
    },
    {
        flag: waybillStateFlagsEnum.HasRejectedDelivery,
        message:
            "Получатель отказался от приёмки груза. Продолжите оформление ЭТрН в Контуре: оформите необходимые титулы, включая Т7 и завершающий Т4.",
        action: "Перейти в Контур",
    },
    {
        flag: waybillStateFlagsEnum.HasExternalRevisions,
        message: "Получено исправление титула ЭТрН. Подпишите его в Контуре",
        action: "Подписать в Контуре",
    },
].map((warning) => ({ ...warning, intValue: flagVal(waybillStateFlags, warning.flag) }));

/** Keep delivery and revision warnings independent and bound to the current document. */
export const WaybillExternalWarnings = ({
    waybill,
    className,
}: {
    waybill: WaybillExternalState;
    className?: string;
}) => {
    const externalLink = waybill.externalLink?.trim();
    const activeWarnings = warnings.filter(({ intValue }) => (waybill.intStateFlags & intValue) === intValue);
    if (!activeWarnings.length) {
        return null;
    }
    return (
        <div className={className}>
            {activeWarnings.map(({ flag, message, action }) => (
                <div
                    key={flag}
                    className="alert alert-warning d-flex flex-wrap justify-content-between align-items-center mb-2 p-2"
                    role="alert"
                >
                    <div className="d-flex align-items-center mr-2">
                        <IconAlertTriangle size={16} className="mr-2 flex-shrink-0" />
                        <span>{message}</span>
                    </div>
                    {externalLink ? (
                        <a
                            className="inline-btn inline-btn--share mt-1"
                            href={externalLink}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {action}
                        </a>
                    ) : (
                        <div className="d-flex flex-column align-items-end mt-1">
                            <button
                                type="button"
                                className="inline-btn inline-btn--share inline-btn--disabled bg-transparent"
                                disabled
                            >
                                {action}
                            </button>
                            <small className="mt-1">Ссылка на Контур не получена</small>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
